/**
 * Length of a value as the API - and therefore Dataverse - will receive it.
 *
 * A <textarea> exposes its value to JavaScript with LF line breaks, but when a FormData is
 * serialised as multipart/form-data the HTML standard requires every line break in an entry value
 * to be normalised to CRLF. So each line break costs 2 characters of the Dataverse column budget,
 * and a blank line between paragraphs costs 4.
 *
 * Measuring `value.length` instead would let a field pass client validation and still be rejected
 * by the platform, e.g. 2000 characters in the browser arriving as 2008 at the API.
 *
 * Single-line inputs cannot contain newlines, so for them this is identical to `value.length`.
 *
 * @param lineBreakCost 2 (default) for forms posted as multipart/form-data, where the browser
 *   rewrites line breaks to CRLF. Pass 1 for forms posted as JSON (`http.post` with a plain object,
 *   bound server-side with `[FromBody]`), where LF is preserved and the browser's own count is
 *   already what the server receives - the Application Report page is one of these.
 */
export function storedLength(value: unknown, lineBreakCost: number = 2): number {
  if (typeof value !== 'string' || value.length === 0) return 0;
  if (lineBreakCost === 1) return value.replace(/\r\n/g, '\n').length;
  return value.replace(/\r\n|\r|\n/g, '\r\n').length;
}
